module.exports = __webpack_public_path__ + "static/media/cl_trade_arrow_red.f0e3c068.svg";